import React from 'react';
import PropTypes from 'prop-types';

const ArrowSwitchHorizontal = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.3125 7.125L1.5 4.3125M1.5 4.3125L4.3125 1.5M1.5 4.3125H16.5M13.6875 10.875L16.5 13.6875M16.5 13.6875L13.6875 16.5M16.5 13.6875H1.5"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowSwitchHorizontal.propTypes = {
  color: PropTypes.string,
};

export default ArrowSwitchHorizontal;
